<template>
  <div
    class="author-inside-card px-4 py-2 d-flex flex-column flex-lg-row align-items-center justify-content-between"
  >
    <div class="pl-0">
      <router-link :to="{ name: 'users.show', params: { username: user.username } }">
        <div class="d-flex flex-column flex-lg-row align-items-center justify-content-start">
          <div class="mr-lg-4">
            <div
              class="author-image-circle background-cover shadow-light"
              :style="{ backgroundImage: `url('${user.avatar}')` }"
            ></div>
          </div>
          <div class="text-center text-lg-left" style="line-height: 1;">
            <span class="font-size-regular font-weight-bold text-color1 d-block d-flex align-items-center justify-content-start">
              {{ user.name }}
              <BaseIcon
                v-if="user.is_verified"
                size="xxSmall"
                class="ml-1"
              >
                <VerifiedIcon
                  class="profile"
                />
              </BaseIcon>
            </span>
            <span class="text-color1 font-size-small"><span class="text-color2">@</span>{{ user.username }}</span>
          </div>
        </div>
      </router-link>
    </div>
    <div class="actions text-right mt-2 mb-2 d-lg-flex flex-lg-nowrap">
      <FollowButton
        :isFollowed="user.is_followed"
        :idToFollow="user.id"
        v-if="authUser && authUser.id !== user.id"
        class="btn-sm"
        @follow-toggled="followToggled"
      />
      <Button
        class="btn-circle btn-outline-color2 d-inline-block ml-2"
        @click="handleTrashClick"
        v-if="trash && (authUser && authUser.id !== user.id)"
        :loading="trashLoader"
      >
        <i class="fa fa-trash"></i>
      </Button>
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex'

import Button from '@/components/common/Button/Button'
import FollowButton from '@/components/follow/FollowButton'

import BaseIcon from '@/components/common/Icon/BaseIcon'
import VerifiedIcon from '@/components/common/Icon/VerifiedIcon'

export default {
  name: 'UserListItem',
  props: ['user', 'trash'],
  data () {
    return {
      trashLoader: false
    }
  },
  components: {
    Button,
    BaseIcon,
    FollowButton,
    VerifiedIcon
  },
  computed: {
    ...mapState('users', {
      authUser: state => state.user
    })
  },
  methods: {
    followToggled (e) {
      this.$emit('follow-toggled', e)
    },
    handleTrashClick () {
      this.trashLoader = true
      this.$emit('trash-clicked', this.user)
    }
  }
}
</script>
